var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInsurance140 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M69.5 8a.5.5 0 0 1 .5.5v11.502c28.232.245 52.09 21.21 55.995 48.427a.498.498 0 0 1-.495.571h-112a.5.5 0 0 1-.495-.571C16.91 41.213 40.768 20.247 69 20.002V8.5a.5.5 0 0 1 .5-.5Zm.5 60h26.998C96.81 48.35 85.606 31.122 70 21.393V68Zm-1-46.607V68H42.002C42.19 48.35 53.394 31.122 69 21.393ZM14.08 68c4.019-26.026 26.652-46.116 53.627-46.972C52.244 31 41.188 48.286 41.002 68H14.08Zm57.213-46.972C86.755 31 97.813 48.286 97.998 68h26.922c-4.019-26.026-26.652-46.116-53.627-46.972Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M69.5 80a.5.5 0 0 1 .5.5v36c0 6.352 5.148 11.5 11.5 11.5S93 122.852 93 116.5a.5.5 0 0 1 1 0c0 6.904-5.596 12.5-12.5 12.5S69 123.404 69 116.5v-36a.5.5 0 0 1 .5-.5Z",
  clipRule: "evenodd"
})));
export { SvgInsurance140 as ReactComponent };
export default __webpack_public_path__ + "2aa7e3f25f500df08c3c9ead584f9f68.svg";